import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "card-footer text-center flex-column d-flex" }
const _hoisted_5 = {
  class: "btn-group btn-group-sm",
  role: "group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h5", { class: "card-header d-flex align-items-center" }, [
      _createElementVNode("span", null, [
        _createElementVNode("i", { class: "fas fa-pen-nib me-2" }),
        _createTextVNode("Enlace de registro ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        class: "form-control form-control-sm",
        id: "referralUrl",
        "data-bs-toggle": "tooltip",
        "data-bs-trigger": "manual",
        "data-bs-placement": "top",
        title: "Copiado al Portapapeles",
        placeholder: _ctx.registrationLink,
        readonly: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("h6", { class: "small d-none" }, "Copiar enlace de registro:", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.linkbuttonClass('left')),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard('izq')))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "far fa-copy me-1" }, null, -1),
          _createTextVNode(" Izquierda ", -1)
        ]))], 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(_ctx.linkbuttonClass('right')),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboard('der'))),
          mouseout: "outFunc('der')"
        }, [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Derecha ", -1),
          _createElementVNode("i", { class: "far fa-copy ms-1" }, null, -1)
        ]))], 2)
      ])
    ])
  ]))
}